import { type FC } from 'react'
import classNames from 'classnames'
import { Button } from '../../../components/Button/Button'
import styles from './ScheduleSaveBar.module.scss'
import { type TimeSelectionMode } from './form/SetTimeSection'

interface ScheduleSaveBarProps {
  formId: string
  mode: TimeSelectionMode
  isValid: boolean
  isSubmitting: boolean
  onCopyLink: () => void
  onPushToDraft: () => void
}

// Full-width dark action bar sticky to the bottom of the schedule flow. The "Let the client
// choose" mode adds the booking-link actions; "Propose a specific time" only sends the invite.
export const ScheduleSaveBar: FC<ScheduleSaveBarProps> = ({ formId, mode, isValid, isSubmitting, onCopyLink, onPushToDraft }) => (
  <div className={classNames('position-sticky bottom-0 zocks-bg-color-gray-900 p-3 mt-4 rounded-top', styles.bar)}>
    <div className='d-flex align-items-center justify-content-between'>
      <div>
        {mode === 'client-chooses' ? (
          <Button type='button' variant='darkLink' onClick={onCopyLink} disabled={!isValid || isSubmitting}>
            <i className='bi bi-copy me-1' />
            Copy booking link
          </Button>
        ) : null}
      </div>
      <div className='d-flex zocks-gap-0.75'>
        {mode === 'client-chooses' ? (
          <Button type='button' variant='dark' onClick={onPushToDraft} disabled={!isValid || isSubmitting}>
            <i className='bi bi-inbox me-1' />
            Push to draft
          </Button>
        ) : null}
        <Button type='submit' form={formId} variant='primary' className='border-0' disabled={!isValid || isSubmitting} loading={isSubmitting}>
          <i className='bi bi-send me-1' />
          Send
        </Button>
      </div>
    </div>
  </div>
)
